import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Download, Sparkles, BarChart3, Award } from "lucide-react";

const ICONS = [Download, Sparkles, BarChart3, Award];

const HowItWorks = () => {
  const { t } = useLanguage();
  return (
    <section
      data-testid="how-section"
      className="relative py-24 sm:py-28"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-10">
        <div className="max-w-3xl mb-14">
          <span className="text-xs font-bold tracking-[0.2em] uppercase text-amber-600">
            {t.how.eyebrow}
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-blue-950 leading-[1.05]">
            {t.how.title}
          </h2>
        </div>

        <div className="relative">
          {/* Decorative line behind cards */}
          <div className="hidden md:block absolute top-16 left-0 right-0 h-px bg-gradient-to-r from-transparent via-amber-300 to-transparent" />

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 relative">
            {t.how.steps.map((step, i) => {
              const Icon = ICONS[i];
              return (
                <div
                  key={step.n}
                  data-testid={`how-step-${i}`}
                  className="card-lift relative bg-white border border-blue-900/10 rounded-2xl p-7"
                >
                  <span
                    className="absolute -top-3 left-7 inline-flex items-center text-[10px] font-bold tracking-[0.2em] uppercase text-white bg-blue-950 px-2.5 py-1 rounded-full"
                    style={{ fontFamily: "Outfit, sans-serif" }}
                  >
                    Step {step.n}
                  </span>
                  <div className="h-14 w-14 rounded-2xl bg-amber-500/10 text-amber-600 flex items-center justify-center mt-2">
                    <Icon size={26} strokeWidth={2} />
                  </div>
                  <h3 className="mt-5 text-xl font-bold text-blue-950 tracking-tight">
                    {step.title}
                  </h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                    {step.desc}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
